import { handleSelectDataSource, handleSelectRequestConfig, setAdvancedConfigToProps, } from '@/common/util/util';
import { DisplayPosition } from '@/common/manager/position/display-position';
import { componentMap as formComponentMap, Transfer as UITransfer, } from '@cainiaofe/cn-ui';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'Transfer',
    formComponent: formComponentMap.CnTransfer || UITransfer,
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state } = config;
        handleSelectRequestConfig({
            componentProps: formItem?.['x-component-props'],
            isDesign,
            urlParamsDataSource: urlParams,
            recordDataSource: formValue,
            state,
        });
        handleSelectDataSource({
            componentProps: formItem?.['x-component-props'],
            state,
        });
        setAdvancedConfigToProps(formItem?.['x-component-props']);
    },
};
